module.exports = __webpack_public_path__ + "img/tjls-logo-bottom.d63c3a11.png";